import React from "react";
import { useParams } from "react-router-dom";
import useAxios from "axios-hooks";
import API from "src/classes/API";

const formatPhones = (phones) => {
    const numbers = (phones || [])
        .map((p) => p && p.number)
        .filter(Boolean)
        .map((n) => `0${n.slice(-10)}`);

    if (numbers.length === 0) return "";
    return `${numbers.join("/")} + WhatsApp`;
};

const agencyHashtag = (agency) => {
    const name = agency && agency.name;
    if (!name) return "";
    return `#${name.trim().replace(/\s+/g, "_")}`;
};

// "Import From" is not a top-level field — it lives inside Features[].items[].
// Item titles are localized, so we locate the item's index once using the
// English response (title === "Import From") and read the value at that same
// index from each language's response.
const flattenItems = (data) =>
    ((data && data.Features) || []).reduce(
        (acc, group) => acc.concat((group && group.items) || []),
        []
    );

const importFromIndex = (data) =>
    flattenItems(data).findIndex(
        (item) => item && typeof item.title === "string" && item.title.trim() === "Import From"
    );

const importFromValue = (data, index) => {
    if (index < 0) return "";
    const item = flattenItems(data)[index];
    return (item && item.value) || "";
};

const Section = ({ data, dir, labels, callText, importFrom }) => {
    if (!data) return null;

    return (
        <div dir={dir}>
            <div>{data.Name}</div>
            <div>{labels.year} {data.Year}</div>
            <div>{labels.importFrom} {importFrom}</div>
            <div>{labels.mileage} {data.Mileage}</div>
            <div>{labels.city} {data.City}</div>
            <div>{callText}</div>
            <div>{formatPhones(data.Phones)}</div>
            <div>{agencyHashtag(data.Agency)}</div>
        </div>
    );
};

const SocialSharePage = () => {
    const { id } = useParams();
    const url = `${API.carDetails}/${id}`;

    const [{ data: en, loading: lo1 }] = useAxios({ url, method: "GET", headers: { lang: "en" } });
    const [{ data: ar, loading: lo2 }] = useAxios({ url, method: "GET", headers: { lang: "ar" } });
    const [{ data: ku, loading: lo3 }] = useAxios({ url, method: "GET", headers: { lang: "fr" } });

    if (lo1 || lo2 || lo3) {
        return <div style={{ background: "#fff", color: "#000", padding: "16px" }}>Loading…</div>;
    }

    const importIdx = importFromIndex(en);

    return (
        <div style={{ background: "#fff", color: "#000", padding: "16px" }}>
            <Section
                data={en}
                dir="ltr"
                callText="For more information please call"
                importFrom={importFromValue(en, importIdx)}
                labels={{ year: "Year:", importFrom: "Import From:", mileage: "Mileage:", city: "City:" }}
            />

            <div>---</div>

            <Section
                data={ar}
                dir="rtl"
                callText="للمزيد من المعلومات الرجاء اتصل"
                importFrom={importFromValue(ar, importIdx)}
                labels={{ year: "الموديل:", importFrom: "مصدر السيارة:", mileage: "المسافة المقطوعة:", city: "المدينة:" }}
            />

            <div>---</div>

            <Section
                data={ku}
                dir="rtl"
                callText="بۆ زانیاری زیاتر تکایە پەیوەندی بە خاوەنەکەی بکە"
                importFrom={importFromValue(ku, importIdx)}
                labels={{ year: "مۆدیل:", importFrom: "شوێنی هاوردەکردن:", mileage: "ماوەی ڕۆیشتوو:", city: "شار:" }}
            />
        </div>
    );
};

export default SocialSharePage;
